var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shadow-button",on:{"click":function($event){$event.stopPropagation();return _vm.handleShadowBtnClick.apply(null, arguments)}}},[_c('ShadowBox',{staticClass:"shadow-box",attrs:{"opacity":"_50"}},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }